export default "__VITE_ASSET__BPrj6_1I__"